import { validateLanguage } from '../lang';
import { getOrganizationConfig } from './organization';

export function getLocale(user, organization) {
  return validateLanguage(
    user.config?.locale || getOrganizationConfig(organization.config, 'locale')
  );
}
